import { Link } from "react-router-dom";

const entries = [
  {
    to: "/category?type=movie",
    icon: "ri-film-line",
    title: "电影频道",
    desc: "动作、科幻、悬疑、爱情，一站式浏览优质影片",
    image:
      "https://readdy.ai/api/search-image?query=cinema%20hall%20with%20warm%20projector%20light%20and%20rows%20of%20empty%20seats%2C%20deep%20navy%20and%20amber%20tones%2C%20cinematic%20painterly%20illustration%2C%20no%20text&width=800&height=500&seq=entry-movie-01&orientation=landscape",
  },
  {
    to: "/category?type=tv",
    icon: "ri-tv-2-line",
    title: "电视剧频道",
    desc: "都市、古装、权谋、青春，追剧人的专属角落",
    image:
      "https://readdy.ai/api/search-image?query=cozy%20living%20room%20at%20night%20with%20a%20glowing%20television%20and%20warm%20lamp%2C%20deep%20blue%20interior%20with%20orange%20glow%2C%20cinematic%20painterly%20illustration%2C%20no%20text&width=800&height=500&seq=entry-tv-01&orientation=landscape",
  },
];

export default function CategoryEntry() {
  return (
    <section className="mx-auto w-full max-w-7xl px-4 py-10 md:px-6 md:py-14">
      <div className="grid grid-cols-1 gap-4 md:grid-cols-2 md:gap-6">
        {entries.map((entry) => (
          <Link
            key={entry.to}
            to={entry.to}
            className="group relative flex h-44 items-center overflow-hidden rounded-lg border border-background-200 md:h-52"
          >
            <img
              src={entry.image}
              alt={`${entry.title}封面`}
              title={`${entry.title} - 色色影院`}
              className="absolute inset-0 h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
            />
            <div className="absolute inset-0 bg-gradient-to-r from-primary-950/90 via-primary-950/60 to-primary-950/10"></div>
            <div className="relative z-10 px-6 md:px-8">
              <span className="flex h-11 w-11 items-center justify-center rounded-lg bg-accent-500 text-background-50">
                <i className={`${entry.icon} text-2xl`}></i>
              </span>
              <h2 className="mt-3 font-heading text-xl font-bold text-background-50 md:text-2xl">
                {entry.title}
              </h2>
              <p className="mt-1.5 max-w-xs text-xs text-background-100/80 md:text-sm">
                {entry.desc}
              </p>
              <span className="mt-3 inline-flex items-center gap-1 text-xs font-semibold text-accent-400">
                立即进入
                <i className="ri-arrow-right-line"></i>
              </span>
            </div>
          </Link>
        ))}
      </div>
    </section>
  );
}